import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  EmptyViewContainer,
  InfoIcon,
} from './styles';

const EmptyView = ({
  content,
}) => (
  <Container>
    <EmptyViewContainer>
      <InfoIcon />
      {content}
    </EmptyViewContainer>
  </Container>
);

EmptyView.propTypes = {
  content: PropTypes.string.isRequired,
};

export default EmptyView;
